<mat-form-field
  aria-label="Email"
  class="presentation-v1 sign-input-v1"
  appearance="outline"
  [ngClass]="{ 'tel-input-wrapper': showCountryCode }"
>
  <mat-label>Email</mat-label>
  <input data-testid="email-phone-input" matInput placeholder="Email" [formControl]="phoneEmailInput" />
  <mat-error>Please enter a valid email.</mat-error>
</mat-form-field>
